import { Box, Flex, Text, useTheme } from "@100mslive/react-ui";

import { ColoredHandIcon } from "@100mslive/react-icons";
import React from "react";
import { useTranslation } from "react-i18next";

function HomePage() {
  const { t } = useTranslation();
  const themeType = useTheme().themeType;
  return (
    <Flex
      align="center"
      justify="center"
      css={{
        size: "100%",
        color: "$textPrimary",
        backgroundColor: "$bgPrimary",
      }}
    >
      <Box css={{ position: "relative", overflow: "hidden", r: "$3" }}>
        <img
          src={
            themeType === "dark"
              ? require("../images/error-bg-dark.svg")
              : require("../images/error-bg-light.svg")
          }
          alt="Error Background"
        />
        <Flex
          align="center"
          direction="column"
          css={{ position: "absolute", size: "100%", top: "33.33%", left: 0 }}
        >
          <Flex>
            <ColoredHandIcon width={40} height={40} />
            <Text
              variant="h4"
              css={{ wordBreak: "break-word", textAlign: "center" }}
            >
              {t("lbl_welcome")}
            </Text>
          </Flex>
          <Text
            variant="h4"
            css={{ wordBreak: "break-word", textAlign: "center" }}
          >
            {t("lbl_hodo_community_events")}
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
}

HomePage.displayName = "HomePage";

export default HomePage;
